import Hubspot from "static/images/Hubspot.svg";
import Stripe from "static/images/Stripe.svg";
import BillCom from "static/images/BillCom.svg";
import QuickBooks from "static/images/QuickBooks.svg";
import Mercury from "static/images/Mercury.svg";

export const REVENUE_DATA_SOURCE = {
  MANUAL: "MANUAL",
  MANUAL_AI: "MANUAL_AI",
  STRIPE: "STRIPE",
  HUBSPOT: "HUBSPOT",
  SALES_TAX_INVOICE: "SALES_TAX_INVOICE",
  JUSTPAID: "JUSTPAID",
  BILL_COM: "BILL_COM",
  QBO_IMPORT: "QBO_IMPORT",
  MERCURY: "MERCURY",
} as const;

export type REVENUE_DATA_SOURCE_TYPES = keyof typeof REVENUE_DATA_SOURCE;

export const REVENUE_DATA_SOURCE_OPTIONS = {
  [REVENUE_DATA_SOURCE.MANUAL]: "Manual",
  [REVENUE_DATA_SOURCE.MANUAL_AI]: "Manual (AI)",
  [REVENUE_DATA_SOURCE.STRIPE]: "Stripe",
  [REVENUE_DATA_SOURCE.HUBSPOT]: "HubSpot",
  [REVENUE_DATA_SOURCE.SALES_TAX_INVOICE]: "Sales Tax Invoice",
  [REVENUE_DATA_SOURCE.JUSTPAID]: "JustPaid",
  [REVENUE_DATA_SOURCE.BILL_COM]: "Bill.com",
  [REVENUE_DATA_SOURCE.QBO_IMPORT]: "QBO Import",
  [REVENUE_DATA_SOURCE.MERCURY]: "Mercury",
} as const;

export const REVENUE_DATA_SOURCE_ICON = {
  [REVENUE_DATA_SOURCE.STRIPE]: Stripe,
  [REVENUE_DATA_SOURCE.HUBSPOT]: Hubspot,
  [REVENUE_DATA_SOURCE.MANUAL]: "",
  [REVENUE_DATA_SOURCE.MANUAL_AI]: "",
  [REVENUE_DATA_SOURCE.SALES_TAX_INVOICE]: "",
  [REVENUE_DATA_SOURCE.JUSTPAID]: "",
  [REVENUE_DATA_SOURCE.BILL_COM]: BillCom,
  [REVENUE_DATA_SOURCE.QBO_IMPORT]: QuickBooks,
  [REVENUE_DATA_SOURCE.MERCURY]: Mercury,
} as const;

export const MANUAL_INVOICE_SOURCES: REVENUE_DATA_SOURCE_TYPES[] = [
  REVENUE_DATA_SOURCE.MANUAL,
  REVENUE_DATA_SOURCE.MANUAL_AI,
];

// Synced sources whose invoices can be re-pulled from the provider and rebooked
export const RESYNCABLE_INVOICE_SOURCES: REVENUE_DATA_SOURCE_TYPES[] = [
  REVENUE_DATA_SOURCE.HUBSPOT,
  REVENUE_DATA_SOURCE.MERCURY,
  REVENUE_DATA_SOURCE.JUSTPAID,
];

export const CUSTOMER_SORT_BY = {
  AMOUNT_PAID: "AMOUNT_PAID",
  AMOUNT_DUE: "AMOUNT_DUE",
  TOTAL_INVOICED_AMOUNT: "TOTAL_INVOICED_AMOUNT",
  NAME: "NAME",
} as const;

export type CUSTOMER_SORT_BY_TYPE =
  (typeof CUSTOMER_SORT_BY)[keyof typeof CUSTOMER_SORT_BY];
